import { z } from 'zod';

// ---- Project List Filters ----

const projectOptionSchema = z.object({
    id: z.number().int(),
    name: z.string(),
    abbreviation: z.string().optional().default(''),
    description: z.string().optional().default(''),
});

const projectDropdownOptionSchema = z.object({
    option: projectOptionSchema,
});

export const projectListFiltersResponseSchema = z.object({
    userFavoriteProjects: z.array(projectOptionSchema).default([]),
    projectOptionsDropdownList: z.array(projectDropdownOptionSchema).default([]),
}).passthrough();

export type ProjectOption = z.infer<typeof projectOptionSchema>;
export type ProjectListFiltersResponse = z.infer<typeof projectListFiltersResponseSchema>;
